/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */

import PropTypes from 'prop-types';
/* eslint-env browser */
import React, { useEffect, useState, useRef } from 'react';
import LazyLoad from 'react-lazyload';
import {
  FormattedMessage,
  injectIntl,
  intlShape,
  defineMessages,
} from 'react-intl';
import { animateScroll, scroller } from 'react-scroll';
import Measure from 'react-measure';
import { useCookies } from 'react-cookie';
import { VIEW_CONTENT, ADD_TO_CART } from 'shared/constants/social-media';
import Price from 'brastrap/promotional/price/Price';
import Rating from 'brastrap/common/rating/Rating';
import StyleColours from 'brastrap/promotional/style-colours/StyleColours';
import Sizes from 'brastrap/promotional/sizes/Sizes';
import SizeGrid from 'brastrap/promotional/size-grid/SizeGrid';
import Link from 'brastrap/containers/link/LinkContainer';
import Messages from 'brastrap/containers/messages/MessagesContainer';
import StockFinder from 'brastrap/containers/stock-finder/StockFinderContainer';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import Accordion from 'brastrap/common/accordion/Accordion';
import Markdown from 'brastrap/editorial/markdown/Markdown';
import Parser from 'html-react-parser';
import { renderToString } from 'react-dom/server';
import isEmpty from 'lodash/isEmpty';
import AddToBagButton from './AddToBagButton';
import BraSizeGuideContainer from '../../../../shared/routes/Product/containers/modals/BraSizeGuideContainer';
import { sendSocialMediaData } from '../../../../shared/utils/socialMedia';
import { dataLayerGA4ViewItem } from '../../../../shared/utils/data-layer';
import SizeSelectorWidget from '../size-selector-widget/SizeSelectorWidget';
import ProductAccessories from '../../../../shared/routes/Product/containers/ProductAccessoriesContainer';
import {
  generalInfoIcon,
  restOfTheWorldCostsIcon,
  returnsInfoIcon,
  deliveryCostsIcon,
} from './product-details-icons';
import ProductPageSkeleton from '../product-page/ProductPageSkeleton';

// import Action from 'brastrap/common/action/Action.jsx';
// import Prompt from 'brastrap/common/prompt/Prompt';

// const messages = defineMessages({
//   addToFavourites: { id: 'actions.favourites', defaultMessage: 'Add to favourites' },
//   promptDescription: { id: 'product-details.prompt.desc', defaultMessage: 'Try our interactive fitting guides' },
//   promptTitle: { id: 'product-details.prompt.title', defaultMessage: 'Try our interactive fitting guides' },
//   share: { id: 'actions.share', defaultMessage: 'Share' }
// });

// TODO: Long run, we should be localising these descriptions in B2.
// Once we have that in place, this should be removed

const messages = defineMessages({
  padded: {
    id: 'product-details.padded',
    defaultMessage: 'Padded',
  },
  'side sling': {
    id: 'product-details.side-sling',
    defaultMessage: 'Side Sling',
  },
  'stretch lace': {
    id: 'product-details.stretch-lace',
    defaultMessage: 'Stretch Lace',
  },
  'long line': {
    id: 'product-details.long-line',
    defaultMessage: 'Long Line',
  },
  seamfree: {
    id: 'product-details.seamfree',
    defaultMessage: 'Seamfree',
  },
  multiway: {
    id: 'product-details.multiway',
    defaultMessage: 'Multiway',
  },
  moulded: {
    id: 'product-details.moulded',
    defaultMessage: 'Moulded',
  },
  'hand wash': {
    id: 'product-details.hand-wash',
    defaultMessage: 'Hand Wash',
  },
  'call-us': {
    id: 'product-details.call-us',
    // eslint-disable-next-line max-len
    defaultMessage:
      'Our shops always have a great range of sizes and styles available, but if you’re planning to pop in to try on this specific style, please give us a call before to check it’s available. Or, why not order Click & Collect (delivery to our shops is FREE!) so you can try on when you visit us - and we’re on hand if you want us to check the fit!',
  },
  'dress-title': {
    id: 'size-grid.dress-title',
    defaultMessage: 'Select Your Size',
  },
  'size-title': {
    id: 'size-grid.size-title',
    defaultMessage: 'Select Your Size',
  },
  'back-title': {
    id: 'size-grid.back-title',
    defaultMessage: 'Select Your Size',
  },
  'select size': {
    id: 'product-details.select-size',
    defaultMessage: 'Please select from the available colour and size options',
  },
  'free-returns': {
    id: 'product-details.free-returns',
    defaultMessage:
      "Fit or shape not right? Don't worry - you can return for free!",
  },
  'product-description': {
    id: 'product-details.tab-description',
    defaultMessage: 'Why we love this',
  },
  'product-details': {
    id: 'product-details.tab-details',
    defaultMessage: 'Details',
  },
  'delivery-and-returns': {
    id: 'product-details.tab-deliveryInformation',
    defaultMessage: 'Delivery, Returns & Exchanges',
  },
  'fabric-composition': {
    id: 'product-details.tab-fabricComposition',
    defaultMessage: 'Fabric Composition',
  },
  preOrder: {
    id: 'product-details.pre-order',
    defaultMessage: 'Pre Order - ',
  },
  outOfStock: {
    id: 'product-details.out-of-stock',
    defaultMessage: 'Out of Stock',
  },
});

const ProductDetails = props => {
  const {
    currency,
    customerDetails,
    onContainerMeasure,
    fetchingSku,
    intl: { formatMessage, locale },
    isMobile,
    product,
    quantity,
    socialMediaChannels,
    selectedSku,
    showSizeGrid,
    showSizePicker,
    showStockFinder,
    sizeGridContainerWidth,
    enableSizeGrid,
    getColoursNotInStock,
    coloursNotInStock,
    featureImageHeight,
    showSkeleton,
  } = props;

  const [activeAccordion, setActiveAccordion] = useState('product-description');

  const [cookies] = useCookies(['']);

  const socialMediaData = {
    customerDetails: customerDetails,
    product: product,
    quantity: quantity,
    currency: currency,
    fbp: cookies._fbp,
    fbc: cookies._fbc,
  };

  const detailsIcons = {
    'general-info': generalInfoIcon,
    'uk-returns-info': returnsInfoIcon,
    'delivery-costs': deliveryCostsIcon,
    'rest-of-the-world-costs': restOfTheWorldCostsIcon,
  };

  const LAST_VIEWED_ITEMS_LIMIT = -16;

  const styleCodeRef = useRef(product.styleCode);
  const selectedSkuRef = useRef(null);

  useEffect(() => {
    if (product && product.styleCode !== '') {
      dataLayerGA4ViewItem(product, currency);
      styleCodeRef.current = product.styleCode;
    }
  }, [product.styleCode]);

  useEffect(() => {
    sendSocialMediaData(VIEW_CONTENT, socialMediaChannels, socialMediaData);
    attachIconsToDeliveryAndReturnsInfo();
  }, []);

  useEffect(() => {
    if (selectedSku && selectedSku !== undefined) {
      fetchColoursNotInStock();
      selectedSkuRef.current = selectedSku;
    }
  }, [selectedSku]);

  useEffect(() => {
    addCurrentProductToRecentlyViewedItems();
  }, [featureImageHeight]);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      selectedSku &&
      !isEmpty(selectedSku) &&
      product.styleCode
    ) {
      const selectedSkuDetails = {
        bandSize: selectedSku.code.replace(
          selectedSku.value.replace('-', ''),
          ''
        ),
        cupSize: selectedSku.value,
        styleCode: product.styleCode,
      };
      sessionStorage.setItem(
        'selectedSkuDetails',
        JSON.stringify(selectedSkuDetails)
      );
    }
  }, [selectedSku, product]);

  /**
   * Checks if difference between two dates is less than or equal to 30 days
   * @param {Date} date
   * @returns {boolean}
   */
  function isWithin30Days(date) {
    const difference = new Date().getTime() - new Date(date).getTime();
    const diffTime = Math.abs(difference);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 30;
  }

  /**
   * Adds latest viewed product to localstorage for recently viewed items rail
   */
  function addCurrentProductToRecentlyViewedItems() {
    if (window && typeof window !== 'undefined' && featureImageHeight > 100) {
      const stringifiedArray = localStorage.getItem('recentlyViewedItems');
      const today = new Date();
      const colour = product?.colour?.colour;
      const recentlyViewedItemDetails = {
        name: `${product?.brand} ${product?.styleName}${
          colour ? ` in ${colour}` : ''
        }`,
        styleColourCode: product?.styleColourCode,
        styleCode: product?.styleCode,
        image: product?.images[0]?.detail,
        price: product?.prices?.price,
        url: product?.url,
        date: today,
      };

      if (stringifiedArray) {
        const array = JSON.parse(stringifiedArray);

        const index = array.findIndex(
          item =>
            item.styleColourCode === recentlyViewedItemDetails.styleColourCode
        );

        if (index > -1) {
          array[index] = recentlyViewedItemDetails;
          array.push(array.splice(index, 1)[0]);
        } else {
          array.push(recentlyViewedItemDetails);
        }

        localStorage.setItem(
          'recentlyViewedItems',
          JSON.stringify(
            array
              .slice(LAST_VIEWED_ITEMS_LIMIT)
              .filter(item => isWithin30Days(item.date))
          )
        );
      } else {
        localStorage.setItem(
          'recentlyViewedItems',
          JSON.stringify([recentlyViewedItemDetails])
        );
      }
    }
  }

  /**
   * Async function to get colours not in stock
   */
  async function fetchColoursNotInStock() {
    await getColoursNotInStock(product.styleCode, selectedSku.code);
  }

  /**
   * function to attach icons to delivery and returns info paragraphs
   * need this as we get this as rich text from contentful, which means there is no way to
   * manipulate layout, so have wrapped it up as a html string, which is parsed from this end
   * and then modified
   */
  function attachIconsToDeliveryAndReturnsInfo() {
    if (typeof window !== 'undefined') {
      attachIconToParagraph('uk-returns-info');
      attachIconToParagraph('delivery-costs');
      attachIconToParagraph('rest-of-the-world-costs');
      attachIconToParagraph('general-info');
    }
  }

  /**
   * function to attach icons to paragraph using svgs
   * @param {string} id
   */
  function attachIconToParagraph(id) {
    const infoParagaphEl = document.getElementById(id);
    if (infoParagaphEl !== null)
      infoParagaphEl.outerHTML += renderToString(detailsIcons[id]);
  }

  const formattedAccordions = props.tabs.map(accordion => {
    const formattedAccordion = accordion;
    if (accordion.id === 'product-details') {
      if (Array.isArray(accordion.content)) {
        formattedAccordion.content = accordion.content.map(content => {
          const key = content && content.toLowerCase();
          return messages[key] ? formatMessage(messages[key]) : content;
        });
      }
    }
    formattedAccordion.title = messages[accordion.id]
      ? formatMessage(messages[accordion.id])
      : accordion.title;
    return formattedAccordion;
  });

  const selectedSkuCurrent =
    selectedSku &&
    ((selectedSku.skuCode &&
      selectedSku.skuCode.indexOf(product.styleColourCode) !== -1) ||
      (typeof selectedSku === 'string' &&
        selectedSku.indexOf(product.styleColourCode) !== -1))
      ? selectedSku
      : null;

  const selectedSkuCode =
    selectedSkuCurrent &&
    (typeof selectedSkuCurrent === 'string'
      ? selectedSkuCurrent
      : selectedSkuCurrent.skuCode);

  const colours = product.availableColours.map(styleColour => ({
    ...styleColour,
    selected: styleColour.styleColourCode === product.styleColourCode,
    styleColourId: styleColour.styleColourId,
  }));

  const selectedColor = colours
    .filter(item => item.selected)
    .map((item, key) => (
      <span
        key={key}
        className="c-product-details__selected-colour-name"
      >{`${item.name}`}</span>
    ));

  const buttonModifiers = ['large', 'major', 'pdp'];

  /**
   * Map selected UK Cup size to US Size and stringifies depending on if it is a range or not - pretty dumb implementation atm, TODO: Make smarter
   * @param {string} cupSize
   * @returns {string}
   */
  function mapSelectedUKCupSizeToUS(cupSize) {
    let convertedString;
    const splitSizes = cupSize.split('-');

    if (splitSizes.length > 1) {
      convertedString = splitSizes.map(x => convertFromUKtoUS(x)).join(' - ');
    } else {
      convertedString = convertFromUKtoUS(cupSize);
    }

    /**
     * converts from UK to US Size
     * @param {string} cupSizeToConvert
     * @returns {string}
     */
    function convertFromUKtoUS(cupSizeToConvert) {
      let usConversion;
      switch (cupSizeToConvert) {
        case 'AA':
          usConversion = 'AA';
          break;
        case 'A':
          usConversion = 'A';
          break;
        case 'B':
          usConversion = 'B';
          break;
        case 'C':
          usConversion = 'C';
          break;
        case 'D':
          usConversion = 'D';
          break;
        case 'DD':
          usConversion = 'DD';
          break;
        case 'E':
          usConversion = 'DDD/F';
          break;
        case 'F':
          usConversion = 'DDDD/G';
          break;
        case 'FF':
          usConversion = 'H';
          break;
        case 'G':
          usConversion = 'I';
          break;
        case 'GG':
          usConversion = 'J';
          break;
        case 'H':
          usConversion = 'K';
          break;
        case 'HH':
          usConversion = 'L';
          break;
        case 'J':
          usConversion = 'M';
          break;
        case 'JJ':
          usConversion = 'N';
          break;
        case 'K':
          usConversion = 'O';
          break;
        case 'KK':
          usConversion = 'P';
          break;
        case 'L':
          usConversion = 'Q';
          break;
        default:
          usConversion = null;
      }
      return usConversion;
    }

    return convertedString ? ` (US ${convertedString})` : '';
  }

  /**
   * Builds content for accordion - as this can come back in many different formats from contentful (array of bullets, string etc) - we have to check for each type and build the jsx accordingly
   * @param {object | string | Array} content
   * @returns {object}
   */
  function buildAccordionContent(content) {
    let contentToReturn;
    if (Array.isArray(content)) {
      if (typeof content[0] === 'string') {
        contentToReturn = (
          <ul>
            {content.map((bullet, key) => (
              <li key={key}>{bullet}</li>
            ))}
          </ul>
        );
      } else if (typeof content[0] === 'object') {
        contentToReturn = <EditorialContainer containers={content} />;
      }
    } else if (
      typeof content === 'string' &&
      content.startsWith('<') &&
      content.endsWith('>')
    ) {
      if (typeof window !== 'undefined') {
        contentToReturn = Parser(`<div>${content}</div>`);
      }
    } else {
      contentToReturn = <Markdown content={content} />;
    }
    return contentToReturn;
  }

  /**
   * @param {object} sku
   * @returns {JSX}
   */
  function buildStockStatusJsx(sku) {
    return (
      <div
        id="stock-status"
        className={`size-selector-widget__status--${
          sku.stockStatusKey.charAt(0).toLowerCase() +
          sku.stockStatusKey.slice(1)
        }`}
      >
        {sku.stockStatusKey === 'OnOrder' &&
          `${formatMessage(messages.preOrder)} ${sku.stockStatus}`}
        {sku.stockStatusKey === 'Unavailable' &&
          formatMessage(messages.outOfStock)}
        {sku.stockStatusKey !== 'Unavailable' &&
          sku.stockStatusKey !== 'OnOrder' &&
          sku.stockStatus}
      </div>
    );
  }

  return (
    <Measure onMeasure={({ width }) => onContainerMeasure(width)}>
      <div
        className="c-product-details"
        data-style-colour-code={product.styleColourCode}
      >
        <header className="c-product-details__header">
          <div className="c-product-details__titleAndPriceContainer">
            <div className="c-product-details__title">
              <small className="c-product-details__code">
                {styleCodeRef.current}
              </small>
              <h1>
                <span className="c-product-details__brand">
                  {product.brand}
                </span>
                <span className="c-product-details__name">
                  {product.styleName}
                </span>
              </h1>
            </div>

            <p className="c-product-details__price">
              {!showSkeleton && (
                <Price {...product.prices} currency={props.currency} />
              )}
            </p>
          </div>
          <p className="c-product-details__rating">
            {product.ratings &&
            product.ratings.rating &&
            product.ratings.rating.total ? (
              <span className="c-product-details__ratingsContainer">
                <Rating {...product.ratings.rating} hideRatingTotalString />
                <Link
                  className="c-product-details__rating-link"
                  onClick={() => scroller.scrollTo('reviews')}
                >
                  <FormattedMessage
                    id="product-details.read-reviews"
                    defaultMessage="{number} reviews"
                    values={{ number: product.ratings.rating.total }}
                  />
                </Link>
              </span>
            ) : (
              <Link
                to="write-review/"
                rel="nofollow"
                className="c-product-details__write-a-review-link"
              >
                <FormattedMessage
                  id="product-details.write.first-review"
                  defaultMessage="Write the first review"
                />
              </Link>
            )}
          </p>
        </header>

        {isMobile && product.sizeGuideUrl && (
          <div className="c-product-details__mobileSizeGuideLinkContainer">
            <BraSizeGuideContainer
              url={product.sizeGuideUrl.slug}
              category={product.category}
              locale={locale}
            />
          </div>
        )}

        <div className="c-product-details__style-colours">
          {showSkeleton ? (
            <ProductPageSkeleton isMobile={isMobile} type="swatches" />
          ) : (
            <>
              <h1 className="c-product-details__selected-colour">
                <FormattedMessage
                  id="product-details.selected-colour-name"
                  defaultMessage="Colour"
                />
                &nbsp; {selectedColor && '|'}
                <span className="size-selector-widget__header--currentSelectedItem">
                  {selectedColor}
                </span>
              </h1>
              <StyleColours
                styleCode={product.styleCode}
                selectedSku={selectedSkuCurrent}
                isMobile={isMobile}
                list={colours}
                modifiers={['large']}
                locationAttribute="to"
                coloursNotInStock={coloursNotInStock}
                product={product}
              />
            </>
          )}
        </div>

        {showSizePicker && !showSkeleton && (
          <div className="c-product-details__sizes">
            <Sizes
              modifiers={['large']}
              open={props.showBraSelect}
              onModalClose={props.onModalClose}
              onChange={props.onProductSelect}
              onModalOpen={props.onModalOpen}
              modalId={props.modalId}
              isOpen={props.isOpen}
              sizes={product.sizes}
              value={
                selectedSkuCurrent
                  ? selectedSkuCurrent.skuCode || selectedSkuCurrent
                  : null
              }
              layer={props.layer}
              selectedSku={selectedSkuCurrent}
              isMobile={isMobile}
              locale={locale}
              // TODO: function used within JSX prop as part of the PDP project, this will need to be rectified
              // eslint-disable-next-line react/jsx-no-bind
              mapSelectedUKCupSizeToUS={mapSelectedUKCupSizeToUS}
              styleCode={product.styleCode}
              selectedSkuRef={selectedSkuRef}
              product={product}
            />
          </div>
        )}

        {showSizePicker && showSkeleton && (
          <ProductPageSkeleton isMobile={isMobile} type="sizeSelector" />
        )}

        {showSizeGrid && (
          <div className="c-product-details__size-grid">
            {/* TODO: nested ternary introduced by PDP project, needs resolving */}
            {/* eslint-disable-next-line no-nested-ternary */}
            {enableSizeGrid ? (
              <>
                <h2 className="c-product-details__size-grid__title">
                  <span
                    className={`c-product-details__brand ${
                      !product.sizeGuideUrl && 'u-center'
                    }`}
                  >
                    {formatMessage(
                      messages[`${product.sizes.value}-title`] ||
                        messages['size-title']
                    )}
                  </span>
                </h2>
                {product.sizeGuideUrl && (
                  <BraSizeGuideContainer
                    url={product.sizeGuideUrl.slug}
                    category={product.category}
                    locale={locale}
                  />
                )}
                <SizeGrid
                  sizes={product.sizes}
                  containerWidth={sizeGridContainerWidth}
                  onChange={props.onSizeGridProductSelect}
                  value={selectedSkuCurrent}
                  selectedSku={selectedSkuCurrent}
                />
              </>
            ) : showSkeleton ? (
              <ProductPageSkeleton isMobile={isMobile} type="sizeSelector" />
            ) : (
              <SizeSelectorWidget
                sizes={product.sizes}
                onChange={props.onSizeGridProductSelect}
                locale={locale}
                styleCode={product.styleCode}
                getColoursNotInStock={(styleCode, size) =>
                  getColoursNotInStock(styleCode, size)
                }
                // TODO: function used within JSX prop as part of the PDP project, this will need to be rectified
                // eslint-disable-next-line react/jsx-no-bind
                mapSelectedUKCupSizeToUS={mapSelectedUKCupSizeToUS}
                braSizeGuideUrl={product.sizeGuideUrl}
                productCategory={product.category}
                selectedSkuRef={selectedSkuRef}
                product={product}
              />
            )}
          </div>
        )}

        <div className="c-product-details__statusAndStockFinderContainer">
          {/* TODO: nested ternary introduced by PDP project, needs resolving */}
          {/* eslint-disable-next-line no-nested-ternary */}
          {selectedSku && selectedSku.stockStatusKey && !showSkeleton ? (
            buildStockStatusJsx(selectedSku)
          ) : selectedSkuRef.current &&
            selectedSkuRef.current.stockStatusKey &&
            !showSkeleton ? (
            buildStockStatusJsx(selectedSkuRef.current)
          ) : (
            <div />
          )}
          {showStockFinder && <StockFinder />}
        </div>

        <Messages target="productDetails" />
        <div className="c-product-details__add-to-bag">
          <AddToBagButton
            isAdded={props.isAdded}
            isFetching={fetchingSku && fetchingSku === selectedSkuCode}
            onClick={() => {
              if (quantity > 0) {
                if (
                  (selectedSkuCurrent &&
                    selectedSku.stockStatusKey !== 'Unavailable') ||
                  (selectedSkuRef.current &&
                    selectedSkuRef.current.stockStatusKey !== 'Unavailable')
                ) {
                  sendSocialMediaData(
                    ADD_TO_CART,
                    socialMediaChannels,
                    socialMediaData
                  );

                  if (selectedSkuCurrent) {
                    props.onAddToCart(
                      selectedSkuCurrent.skuCode || selectedSkuCurrent,
                      quantity,
                      null
                    );
                  } else if (selectedSkuRef.current) {
                    props.onAddToCart(
                      selectedSkuRef.current.skuCode || selectedSkuRef.current,
                      quantity,
                      null
                    );
                  }

                  if (!isMobile) {
                    animateScroll.scrollToTop({
                      duration: 500,
                    });
                  }
                } else {
                  props.onAddToCart(
                    selectedSkuCurrent,
                    quantity,
                    props.intl.formatMessage(messages['select size'])
                  );
                }
              }
            }}
            modifiers={
              (!selectedSku || selectedSku.stockStatusKey === 'Unavailable') &&
              (!selectedSkuRef.current ||
                selectedSkuRef.current.stockStatusKey === 'Unavailable')
                ? buttonModifiers.concat(['disabled'])
                : buttonModifiers
            }
          />
        </div>

        {showSkeleton ? (
          <ProductPageSkeleton isMobile={isMobile} type="accessories" />
        ) : (
          <LazyLoad>
            <ProductAccessories />
          </LazyLoad>
        )}

        {product.sizeGridContainers && !!product.sizeGridContainers.length && (
          <EditorialContainer containers={product.sizeGridContainers} />
        )}
        <LazyLoad>
          <Accordion activeChild={activeAccordion}>
            {formattedAccordions.map(item => (
              <Accordion.Item
                id={item.id}
                key={item.id}
                label={item.title}
                needsResize={false}
                onClick={() => setActiveAccordion(item.id)}
              >
                {buildAccordionContent(item.content)}
              </Accordion.Item>
            ))}
          </Accordion>
        </LazyLoad>
        {product.tabContainers && !!product.tabContainers.length && (
          <LazyLoad>
            <EditorialContainer containers={product.tabContainers} />
          </LazyLoad>
        )}
      </div>
    </Measure>
  );
};

ProductDetails.propTypes = {
  confirmationMessage: PropTypes.string,
  currency: PropTypes.string,
  customerDetails: PropTypes.shape({
    email: PropTypes.string,
  }),
  errorMessage: PropTypes.string,
  fetchingSku: PropTypes.string,
  intl: intlShape,
  isAdded: PropTypes.bool,
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
  layer: PropTypes.object.isRequired,
  modalId: PropTypes.string,
  onAddToCart: PropTypes.func.isRequired,
  onCloseMessages: PropTypes.func.isRequired,
  onProductSelect: PropTypes.func.isRequired,
  onSizeGridProductSelect: PropTypes.func.isRequired,
  onTabSelect: PropTypes.func.isRequired,
  onColourSwatchSelect: PropTypes.func.isRequired,
  onModalOpen: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onContainerMeasure: PropTypes.func.isRequired,
  getColoursNotInStock: PropTypes.func,
  product: PropTypes.shape({
    styleColourName: PropTypes.string,
    availableColours: PropTypes.array,
    brand: PropTypes.string,
    category: PropTypes.string,
    colour: PropTypes.string,
    colours: PropTypes.array,
    images: PropTypes.any,
    prices: PropTypes.shape({
      price: PropTypes.number.isRequired,
      originalPrice: PropTypes.number,
    }),
    quantity: PropTypes.number,
    ratings: {
      rating: PropTypes.shape({
        size: PropTypes.number,
        total: PropTypes.number,
        value: PropTypes.number.isRequired,
      }),
    },
    sizes: PropTypes.shape({
      value: PropTypes.string,
      variants: PropTypes.array,
    }),
    sizeGridContainers: PropTypes.array,
    sizeGuideUrl: PropTypes.shape({
      slug: PropTypes.string,
    }),
    styleColourCode: PropTypes.string.isRequired,
    styleCode: PropTypes.string.isRequired,
    styleName: PropTypes.string.isRequired,
    reviews: PropTypes.array,
    tabContainers: PropTypes.array,
    url: PropTypes.string,
  }),
  quantity: PropTypes.number,
  socialMediaChannels: PropTypes.array,
  selectedSku: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showBraSelect: PropTypes.bool,
  showSizeGrid: PropTypes.bool,
  showSizePicker: PropTypes.bool,
  showStockFinder: PropTypes.bool,
  sizeGridContainerWidth: PropTypes.number,
  tabs: PropTypes.array,
  enableSizeGrid: PropTypes.bool,
  coloursNotInStock: PropTypes.array,
  featureImageHeight: PropTypes.number,
  showSkeleton: PropTypes.bool,
};

ProductDetails.defaultProps = {
  currency: 'GBP',
  onAddToCart: () => {},
  onProductSelect: () => {},
  onModalOpen: () => {},
  onModalClose: () => {},
  onTabSelect: () => {},
  onColourSwatchSelect: () => {},
  onContainerMeasure: () => {},
  getColoursNotInStock: () => {},
  tabs: [],
  showBraSelect: false,
  layer: {},
};

export default injectIntl(ProductDetails);
